import script from "./product-list.vue?vue&type=script&setup=true&lang=js"
export * from "./product-list.vue?vue&type=script&setup=true&lang=js"

import "./product-list.vue?vue&type=style&index=0&id=812d3fc6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-812d3fc6"]])

export default __exports__